"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var models_1 = require("./models");
var moment_addon_1 = __importDefault(require("../../Addons/moment-addon"));
exports.default = vue_1.default.extend({
    name: "HeDatatableHeader",
    props: {
        value: {
            default: function () { return null; },
        },
        formatDate: {
            default: function () { return "DD/MM/YYYY"; },
        },
        allOptionId: {
            default: function () { return ""; },
        }
    },
    data: function () {
        return {
            column: this.value,
            options: [],
            search: {
                operateur: 0,
                value: this.value["typefilter"] === models_1.DatatableColumnTypeEnum.select
                    ? []
                    : "",
            },
            popoverShow: false,
        };
    },
    created: function () {
        if (this.column.typefilter === models_1.DatatableColumnTypeEnum.select
            && this.column.typeselectfilter === models_1.DatatableSelectTypeEnum.custom_select
            && this.url) {
            this.fetchOptions().then();
        }
    },
    computed: {
        cssClass: function () {
            var classes = ["column"];
            if (this.column.searchable) {
                classes.push("searchable");
            }
            if (this.column.orderable) {
                classes.push("orderable");
            }
            if (this.column.displayable) {
                classes.push("displayable");
            }
            if (this.column.visible && this.column.displayable) {
                classes.push("visible");
            }
            if (this.searchs.length > 0
                && (!this.isColumnType(models_1.DatatableColumnTypeEnum.select)
                    || this.column.typeselectfilter !== models_1.DatatableSelectTypeEnum.custom_select
                    || (this.searchs
                        && this.searchs[0]
                        && this.searchs[0].value
                        && this.searchs[0].value[0] !== this.allOptionId))) {
                classes.push("filtered");
            }
            return classes.join(" ");
        },
        DatatableColumnTypeEnum: function () {
            return models_1.DatatableColumnTypeEnum;
        },
        DatatableSelectTypeEnum: function () {
            return models_1.DatatableSelectTypeEnum;
        },
        DatatableRequestSearchOperatorMetadata: function () {
            return models_1.DatatableRequestSearchOperatorMetadata;
        },
        complexFilters: function () {
            return this.column.search
                && this.column.search instanceof Array
                && this.column.search.length > 0
                ? this.column.search.filter(function (f) { return typeof f === "object"; }) || []
                : [];
        },
        searchs: {
            get: function () {
                return this.column.search || [];
            },
            set: function (nv) {
                this.column.search = nv;
            },
        },
    },
    watch: {
        "column.search": function (n) {
            if (this.column.typefilter === models_1.DatatableColumnTypeEnum.select &&
                this.column.typeselectfilter ===
                    models_1.DatatableSelectTypeEnum.custom_select) {
                this.search =
                    this.searchs && this.searchs.length > 0
                        ? this.searchs[0]
                        : {
                            operateur: 0,
                            value: [],
                        };
            }
            else {
                this.getComplexFiltersValues();
                this.reInitSearh();
            }
        },
        "search.value": function (n) {
            this.$set(this.search, "value", n);
        }
    },
    methods: {
        onSelectChange: function (val, $el) {
            this.$set(this.search, "value", val);
        },
        onChangeDate: function (date) {
            this.$set(this.search, "value", date);
        },
        fetchOptions: function () {
            var _this = this;
            return $.ajax({
                url: this.column.urlfilter,
                method: "get",
            }).then(function (data) {
                _this.$set(_this.$data, "options", data.results);
            });
        },
        getOperateurProperty: function (ope, prop) {
            return (this.DatatableRequestSearchOperatorMetadata.find(function (o) { return o.id == ope; })[prop] || "");
        },
        applyFilter: function (event) {
            var fixedSearch = {
                operateur: this.search.operateur,
                value: this.isColumnType(models_1.DatatableColumnTypeEnum.date)
                    ? this.search.value ? moment_addon_1.default(this.search.value, this.formatDate).format(moment_addon_1.default.defaultFormatUtc) : ""
                    : this.search.value
            };
            if (this.isColumnType(models_1.DatatableColumnTypeEnum.select) &&
                this.column.typeselectfilter ===
                    models_1.DatatableSelectTypeEnum.custom_select) {
                this.searchs = [fixedSearch];
            }
            else {
                if (!this.searchs) {
                    this.searchs = [fixedSearch];
                }
                else {
                    this.searchs.push(fixedSearch);
                }
            }
            this.$emit("applyFilter", event, this.column, this.searchs);
            this.$root.$emit("applyFilter", event, this.column, this.searchs);
            this.popoverShow = false;
        },
        deleteFilter: function (event, filterValue, filterOpe) {
            var filter = this.searchs.find(function (f) {
                return typeof f !== "string" &&
                    f.value === filterValue &&
                    f.operateur == filterOpe;
            }), index = this.searchs.indexOf(filter);
            this.searchs.splice(index, 1);
            this.$emit("deleteFilter", event, this.column, this.searchs);
            this.popoverShow = false;
        },
        reInitSearh: function () {
            if (this.isColumnType(models_1.DatatableColumnTypeEnum.select) ||
                this.column.typeselectfilter !==
                    models_1.DatatableSelectTypeEnum.custom_select) {
                this.search = {
                    operateur: 0,
                    value: this.isColumnType(models_1.DatatableColumnTypeEnum.select)
                        ? []
                        : ""
                };
            }
        },
        togglePopover: function () {
            if (!this.popoverShow) {
                this.$parent.closeAllPopover();
            }
            this.popoverShow = !this.popoverShow;
        },
        closePopover: function () {
            this.popoverShow = false;
        },
        isColumnType: function (types) {
            var _this = this;
            if (typeof types !== "object") {
                return this.column.typefilter === types;
            }
            else {
                var isType_1 = false;
                $.map(types, function (t) {
                    if (_this.column.typefilter === t) {
                        isType_1 = true;
                        return;
                    }
                });
                return isType_1;
            }
        },
        getValueFilter: function (val) {
            var _this = this;
            if (!val || val === "") {
                return "null ou vide";
            }
            if (this.isColumnType(models_1.DatatableColumnTypeEnum.date)) {
                if (typeof val === "object") {
                    return $.map(val, function (v) {
                        return moment_addon_1.default(v).format(_this.formatDate);
                    }).join(", ");
                }
                return moment_addon_1.default(val).format(this.formatDate);
            }
            return val instanceof Array ? val.join(", ") : val;
        },
        getComplexFiltersValues: function () {
            var _this = this;
            var filters = this.complexFilters;
            if (!this.column.operatorfilter || filters.length === 0) {
                return filters;
            }
            filters.map(function (f) { return _this.$set(f, "display_value", ""); });
            if (!this.column.urlfilter ||
                (this.column.typefilter === models_1.DatatableColumnTypeEnum.select &&
                    this.column.typeselectfilter ===
                        models_1.DatatableSelectTypeEnum.custom_select)) {
                $.map(filters, function (f) { return (f.display_value = _this.getValueFilter(f.value)); });
                return;
            }
            else {
                $.map(filters, function (f) {
                    if (typeof f === "object") {
                        $.get(_this.column.urlfilter + "?ids=" + f.value).then(function (data) {
                            f.display_value = _this.getValueFilter($.map(data.results, function (d) { return d.text; }));
                        });
                    }
                });
            }
            return filters;
        },
        getSelectedCustomSelectValues: function () {
            var filters = this.complexFilters;
            if (filters.length > 0) {
                return filters[0].value.split(",");
            }
            return [];
        },
    },
    mounted: function () {
        this.getComplexFiltersValues();
    },
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/SharedComponent/HeDatatable/HeDatatableHeader.vue
// module id = 225
// module chunks = 0